import * as types from "../../actions/generalledger/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_GL_REPORT_FILTER_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
